import { InfoItem } from "@/components/molecules";

export const ItemDiscountContent = ({ itemDiscountData }) => {
  const getVal = (v) => v !== undefined && v !== null ? v : '-';

  return (
    <>
      {/*Item Discount Details Section */}
      <div className="order-overview">
        <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
          <InfoItem label="Name" value={getVal(itemDiscountData?.name)} />
          <InfoItem label="Type" value={getVal(itemDiscountData?.type)} />
          <InfoItem
            label="Discount Type Code"
            value={getVal(itemDiscountData?.discountTypeCode)}
          />
          <InfoItem label="Value" value={getVal(itemDiscountData?.value)} />
          <InfoItem label="ID" value={getVal(itemDiscountData?.id)} />
          <InfoItem
            label="Ext Over Discount Percentage"
            value={getVal(itemDiscountData?.extOverDiscountPercentage)}
          />
          <InfoItem
            label="Ext Over Discount Value"
            value={getVal(itemDiscountData?.extOverDiscountValue)}
          />
          <InfoItem
            label="Discount Amount"
            value={getVal(itemDiscountData?.discountAmount)}
          />
          <InfoItem label="Priority" value={getVal(itemDiscountData?.priority)} />
        </div>
      </div>
    </>
  );
};
